// src/components/ProjectCard.jsx
import { Link } from 'react-router-dom';

export default function ProjectCard({ project }) {
  const thumbSrc = project.media && project.media[0] ? project.media[0].thumb : null;

  return (
    <Link
      to={`/project/${project.id}`}
      className="portfolio-card select-none"
      title={`View ${project.title} details`}
    >
      {thumbSrc ? (
        <img
          src={thumbSrc}
          alt={project.title}
          className="portfolio-card-img"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      ) : (
        <div
          className={`h-[230px] w-full bg-gradient-to-br ${project.gradient || 'from-indigo-700 to-purple-900'} flex items-center justify-center`}
        >
          <span className="text-5xl">{project.emoji || '📱'}</span>
        </div>
      )}

      {/* Meyawo Circular-to-full Overlay */}
      <span className="portfolio-card-overlay">
        <span className="portfolio-card-caption">
          <h4>{project.title}</h4>
          <p className="font-weight-normal text-xs mb-2">Category: {project.category}</p>
          <span className="btn btn-sm btn-light rounded shadow-sm">
            View Details
          </span>
        </span>
      </span>
    </Link>
  );
}
